import React from "react";
import PropTypes from "prop-types";
import { Router, Route, Redirect, browserHistory } from "react-router";
import { routerType } from "custom-prop-types";
import { AppContainer } from "containers/app-container";
import { AccountRedirector } from "containers/account-redirector";
import { DocumentsContainer } from "containers/documents-container";
import { PendingDocumentsContainer } from "containers/pending-documents-container";
import { PageNotFoundContainer } from "containers/page-not-found-container";
import { OauthContainer } from "containers/oauth-container";
import { ReportsContainer } from "containers/reports-container";
import { AccountSettingsContainer } from "containers/settings/account-settings-container";
import { AccountUsageContainer } from "containers/settings/account-usage-container";
import { MailInSettingsContainer } from "containers/settings/mail-in-settings-container";
import { SubscriptionSettingsContainer } from "containers/settings/subscription-settings-container";
import { BillingDetailsContainer } from "containers/settings/billing-details-container";
import { BillingHistoryContainer } from "containers/settings/billing-history-container";
import { AccountNameAndEmailContainer } from "containers/settings/account-name-and-email-container";
import { CurrencyTaxLanguageContainer } from "containers/settings/currency-tax-language-container";
import { AccountUsersContainer } from "containers/settings/account-users-container";
import { UserSettingsContainer } from "containers/settings/user-settings-container";
import { UserPasswordContainer } from "containers/settings/user-password-container";
import { UserNameAndEmailContainer } from "containers/settings/user-name-and-email-container";
import { ManageEnvelopesContainer } from "containers/manage-envelopes-container";
import { DashboardContainer } from "containers/dashboard-container";
import { ManageCategoriesContainer } from "containers/manage-categories-container";
import { UploadDocumentsContainer } from "containers/upload-documents-container";
import { ManageVendorsContainer } from "containers/manage-vendors-container";
import { IntegrationSettingsContainer } from "containers/settings/integration-settings-container";
import { BetaSettingsContainer } from "containers/settings/beta-settings-container";
import { FavouriteAccountContainer } from "containers/settings/favourite-account-container";
import { SetUpIntegrationContainer } from "containers/set-up-integration-container";
import { CustomTabContainer } from "containers/custom-tab-container";
import { MyDocumentsContainer } from "containers/my-documents-container";
import { AwaitingMailinContainer } from "containers/awaiting-mailin-container";
import { IssueTrackingFormContainer } from "containers/issue-tracking-form-container";

export const routes = (
  <Router history={ browserHistory } >
    <Route component={ AppContainer } path="/accounts/:accountSlug">
      <Route component={ DashboardContainer } path="dashboard" />
      <Route component={ UploadDocumentsContainer } path="upload" />
      <Redirect from="documents" to="documents/all" />
      <Route component={ MyDocumentsContainer } path="documents">
        <Route component={ (props) => createElement(DocumentsContainer, props) } exact path="all" />
        <Route component={ (props) => createElement(DocumentsContainer, props) } path="filter/:filter" />
        <Route component={ (props) => createElement(DocumentsContainer, props) } path="this-financial-year" />
        <Route component={ (props) => createElement(DocumentsContainer, props) } path="custom/:customTab" />
        <Route component={ CustomTabContainer } path="custom-tab" />
        <Route component={ SetUpIntegrationContainer } path="set-up-integration" />
        <Route path=":envelopeCode" />
      </Route>
      <Route component={ ReportsContainer } path="reports" />
      <Route component={ ManageEnvelopesContainer } path="manage-envelopes" />
      <Route path="settings">
        <Route component={ AccountSettingsContainer } path="account">
          <Route component={ AccountUsageContainer } path="usage" />
          <Route component={ MailInSettingsContainer } path="mail-in" />
          <Route component={ SubscriptionSettingsContainer } path="subscription" />
          <Route component={ BillingDetailsContainer } path="billing-details" />
          <Route component={ BillingHistoryContainer } path="billing-history" />
          <Route component={ AccountNameAndEmailContainer } path="name" />
          <Route component={ CurrencyTaxLanguageContainer } path="tax" />
          <Route component={ AccountUsersContainer } path="users" />
        </Route>
        <Route component={ UserSettingsContainer } path="user">
          <Route component={ UserNameAndEmailContainer } path="info" />
          <Route component={ UserPasswordContainer } path="password" />
          <Route component={ BetaSettingsContainer } path="ui-settings" />
          <Route component={ FavouriteAccountContainer } path="favourite-account" />
        </Route>
        <Route component={ IntegrationSettingsContainer } path="integration" />
      </Route>
      <Route component={ PendingDocumentsContainer } path="awaiting-digital" />
      <Route component={ AwaitingMailinContainer } path="awaiting-mailin" />
      <Redirect from="automate" to="automate/manage-categories" />
      <Route path="automate">
        <Route component={ ManageCategoriesContainer } path="manage-categories" />
        <Route component={ ManageVendorsContainer } path="manage-vendors" />
      </Route>
      <Route component={ IssueTrackingFormContainer } path="issue-tracking-form" />
    </Route>
    <Route component={ AccountRedirector } path="/" />
    <Route component={ OauthContainer } path="/oauth" />
    <Redirect from="/documents/all" to="/" />
    <Route component={ PageNotFoundContainer } path="*" />
  </Router>
);

const createElement = (Component, props) => {
  if (props.router.params.customTab) {
    return <Component key={ `${props.router.params.customTab}RouteComponent` } { ...props } />;
  }
  return <Component key={ `${props.location.key}RouteComponent` } { ...props } />;
};

createElement.propTypes = {
  location: PropTypes.shape({ key: PropTypes.string }).isRequired,
  router: routerType.isRequired
};



// WEBPACK FOOTER //
// ./src/js/routes.jsx